<template>
  <div class="item" :class="{'open': open}">
    <button @click="toggle" draggable="false" ondragstart="return false;">{{title}} <span></span></button>
    <div class="content" ref="content" :style="{'max-height': height}">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "AccordionItem",
  data() {
    return {
      open: false,
      height: '0px'
    }
  },
  props: {
    title: String
  },
  methods: {
    toggle() {
      this.open = !this.open;
      if (this.open) {
        this.height = this.$refs.content.scrollHeight + 'px';
        setTimeout(() => {
          this.height = 'none';
        },500)
      }
      else {
        this.height = this.$refs.content.scrollHeight + 'px';
        setTimeout(() => {
          this.height = '0px';
        },50)
      }
    }
  }
}
</script>

<style scoped>
  .item {
    position: relative;
    display: block;
    font-size: 12px;
  }
  .item:after {
    content: "";
    position: relative;
    display: block;
    height: 3px;
    background-color: #E5E5E5;
    border-radius: 2px;
  }
  .content {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.5s ease-in-out;
    padding-right: 100px;
  }
  .content:after {
    content: "";
    position: relative;
    display: block;
    height: 26px;
  }
  button {
    position: relative;
    display: block;
    font-size: 36px;
    line-height: 1;
    font-weight: 700;
    color: #102D61;
    padding: 18px 0 22px;
    border: 0;
    background-color: transparent;
    font-family: inherit;
    width: 100%;
    text-align: left;
    cursor: pointer;
    margin-left: -0.02em;
  }
  button:focus {
    outline: 0;
  }
  button span {
    position: absolute;
    display: block;
    width: 41px;
    height: 41px;
    border-radius: 50%;
    border: 3px solid #102D61;
    right: 18px;
    top: 50%;
    margin-top: -21px;
  }
  button span:before, button span:after {
    content: "";
    position: absolute;
    top: 16px;
    left: 7px;
    right: 7px;
    height: 3px;
    background-color: #102D61;
    border-radius: 2px;
  }
  button span:after {
    transform: rotate(90deg) scale(1, 1);
    transition: 0.3s ease;
  }
  .open button span:after {
    transform: rotate(90deg) scale(0, 1);
  }
  @media(max-width: 999px) {
    button {
      font-size: 28px;
    }
  }
  @media(max-width: 767px) {
    button {
      font-size: 24px;
      padding: 13px 40px 16px 0;
    }
    button span {
      right: 0;
      width: 34px;
      height: 34px;
      border: 2px solid #102D61;
      margin-top: -17px;
    }
    button span:before, button span:after {
      height: 2px;
      top: 14px;
    }
    .content {
      padding-right: 0;
    }
  }
  @media(max-width: 350px) {
    button {
      font-size: 22px;
    }
  }
</style>